import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function AdminShell({ children, title }) {
  const { role, profile, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const links = [
    { to: "/admin", icon: "ti-dashboard", label: "Dashboard", exact: true },
    { to: "/admin/applicants", icon: "ti-users", label: "Applicants" },
    { to: "/admin/hirings", icon: "ti-briefcase", label: "Available Hirings" },
    { to: "/admin/files", icon: "ti-folder", label: "File Organizer" },
    { to: "/admin/financials", icon: "ti-cash", label: "Financials" },
    { to: "/admin/chat", icon: "ti-message", label: "Chat / Inquiries" },
    { to: "/admin/chatbot-faq", icon: "ti-robot", label: "Chatbot FAQ" },
  ];
  if (role === "superadmin") {
    links.push({ to: "/admin/assignments", icon: "ti-git-branch", label: "Job Assignments" });
    links.push({ to: "/admin/accounts", icon: "ti-user-shield", label: "Manage Admins" });
  }

  const close = () => setSidebarOpen(false);

  const SidebarContent = () => (
    <>
      <div className="admin-sidebar-brand">
        <img src="/logo.png" alt="GG" style={{ height: 38, width: "auto", display: "block", flexShrink: 0 }} />
        <div>
          <div style={{ fontFamily: "var(--font-display)", color: "var(--cream)", fontSize: 15 }}>Golden Gateway</div>
          <div style={{ fontSize: 10, color: "var(--gold-300)", letterSpacing: "0.1em" }}>{role === "superadmin" ? "SUPER ADMIN" : "ADMIN"}</div>
        </div>
        {/* Close button — mobile only */}
        <button onClick={close} className="admin-sidebar-close" aria-label="Close menu">
          <i className="ti ti-x"></i>
        </button>
      </div>
      <nav className="admin-nav">
        {links.map((l) => (
          <NavLink key={l.to} to={l.to} end={l.exact} onClick={close}
            className={({ isActive }) => "admin-nav-item" + (isActive ? " active" : "")}>
            <i className={`ti ${l.icon}`}></i> {l.label}
          </NavLink>
        ))}
      </nav>
      <div style={{ marginTop: 32, paddingTop: 24, borderTop: "1px solid var(--ink-700)" }}>
        <div style={{ padding: "0 8px", fontSize: 12, color: "var(--ink-300)", marginBottom: 8 }}>
          Signed in as<br /><strong style={{ color: "var(--cream)" }}>{profile?.name || profile?.email || "Admin"}</strong>
        </div>
        <button className="admin-nav-item" onClick={() => { logout(); navigate("/"); }} style={{ width: "100%", textAlign: "left" }}>
          <i className="ti ti-logout"></i> Logout
        </button>
      </div>
    </>
  );

  return (
    <div className="admin-shell">
      {/* Desktop sidebar */}
      <aside className="admin-sidebar admin-sidebar-desktop">
        <SidebarContent />
      </aside>

      {/* Mobile overlay + drawer */}
      {sidebarOpen && <div className="admin-mobile-overlay" onClick={close} />}
      <aside className={`admin-sidebar admin-sidebar-mobile ${sidebarOpen ? "open" : ""}`}>
        <SidebarContent />
      </aside>

      <main className="admin-main">
        {/* Mobile top bar */}
        <div className="admin-topbar">
          <button className="admin-hamburger" onClick={() => setSidebarOpen(true)} aria-label="Open menu">
            <i className="ti ti-menu-2"></i>
          </button>
          <div style={{ fontFamily: "var(--font-display)", fontSize: 16, fontWeight: 700 }}>{title || "Dashboard"}</div>
          <div style={{ width: 40 }} />
        </div>

        {title && (
          <div className="page-header admin-desktop-title">
            <h1 className="page-title">{title}</h1>
          </div>
        )}
        {children}
      </main>
    </div>
  );
}
